<script setup lang="ts">
import { useGlobalFileDownload } from '@/composables/useGlobalFileDownload';

// Initialize global file download subscription
useGlobalFileDownload();
</script>

<template>
  <router-view />
</template>
